var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgReporting = function SvgReporting(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M129.041 146H12L35.0612 26H152L129.041 146Z",
    fill: "#E6E6F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M132 129.5H15L14 135.5H131L132 129.5Z",
    fill: "#9FA4D0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 128.5C8 127.672 8.67157 127 9.5 127H136.5C137.328 127 138 127.672 138 128.5C138 129.328 137.328 130 136.5 130H9.5C8.67157 130 8 129.328 8 128.5Z",
    fill: "#313E48"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M125.2 105.139H24C20.7 105.139 18 102.512 18 99.3025V26.8362C18 23.6263 20.7 21 24 21H125.2C128.5 21 131.2 23.6263 131.2 26.8362V99.3025C131.2 102.512 128.5 105.139 125.2 105.139Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 22.5C21.489 22.5 19.5 24.4936 19.5 26.8362V99.3025C19.5 101.645 21.489 103.639 24 103.639H125.2C127.711 103.639 129.7 101.645 129.7 99.3025V26.8362C129.7 24.4936 127.711 22.5 125.2 22.5H24ZM16.5 26.8362C16.5 22.759 19.911 19.5 24 19.5H125.2C129.289 19.5 132.7 22.759 132.7 26.8362V99.3025C132.7 103.38 129.289 106.639 125.2 106.639H24C19.911 106.639 16.5 103.38 16.5 99.3025V26.8362Z",
    fill: "#313E48"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5996 29.908H122.4V97.3009H26.5996V29.908ZM29.5996 32.908V94.3009H119.4V32.908H29.5996Z",
    fill: "#313E48"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9998 120.605V105.042H63.0998V120.605H54.2998V127.9H94.7998V120.605H85.9998Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.5998 103.542H87.4998V119.105H96.2998V129.4H52.7998V119.105H61.5998V103.542ZM64.5998 106.542V122.105H55.7998V126.4H93.2998V122.105H84.4998V106.542H64.5998Z",
    fill: "#313E48"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.9 40.495C44.4975 40.495 41 43.9559 41 48.1384C41 52.3209 44.4975 55.7818 48.9 55.7818C53.3025 55.7818 56.8 52.3209 56.8 48.1384C56.8 43.9559 53.3025 40.495 48.9 40.495ZM38 48.1384C38 42.2213 42.9195 37.495 48.9 37.495C54.8805 37.495 59.8 42.2213 59.8 48.1384C59.8 54.0555 54.8805 58.7818 48.9 58.7818C42.9195 58.7818 38 54.0555 38 48.1384Z",
    fill: "#313E48"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.4004 38.995H50.4004V47.5472L55.8971 53.4376L53.7037 55.4843L47.4004 48.7296V38.995Z",
    fill: "#313E48"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5998 73.3314H39.2998V87.0465H45.5998V73.3314Z",
    fill: "#5FA8DC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.7998 71.8314H47.0998V88.5465H37.7998V71.8314ZM40.7998 74.8314V85.5465H44.0998V74.8314H40.7998Z",
    fill: "#313E48"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0998 78.0004H51.7998V87.0465H58.0998V78.0004Z",
    fill: "#CFD9E1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.2998 76.5004H59.5998V88.5465H50.2998V76.5004ZM53.2998 79.5004V85.5465H56.5998V79.5004H53.2998Z",
    fill: "#313E48"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8002 66.2307H45.7002V87.0465H51.8002V66.2307Z",
    fill: "#EADB9E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.2002 64.7307H53.3002V88.5465H44.2002V64.7307ZM47.2002 67.7307V85.5465H50.3002V67.7307H47.2002Z",
    fill: "#313E48"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4994 70.6078H84.8994C84.2994 70.6078 83.8994 70.1214 83.8994 69.6351V61.2698C83.8994 60.6862 84.3994 60.2971 84.8994 60.2971H93.4994C94.0994 60.2971 94.4994 60.7835 94.4994 61.2698V69.6351C94.4994 70.1214 93.9994 70.6078 93.4994 70.6078Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.3994 61.7971V69.1078H92.9994V61.7971H85.3994ZM82.3994 61.2698C82.3994 59.7246 83.7107 58.7971 84.8994 58.7971H93.4994C94.9856 58.7971 95.9994 60.0141 95.9994 61.2698V69.6351C95.9994 70.381 95.6322 70.9905 95.2328 71.379C94.8308 71.7701 94.2228 72.1078 93.4994 72.1078H84.8994C83.4132 72.1078 82.3994 70.8908 82.3994 69.6351V61.2698Z",
    fill: "#313E48"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9996 72.0669L63.8996 66.1334C63.4996 65.7443 63.4996 65.0634 63.8996 64.6743L69.9996 58.7408C70.3996 58.3518 71.0996 58.3518 71.4996 58.7408L77.5996 64.6743C77.9996 65.0634 77.9996 65.7443 77.5996 66.1334L71.3996 72.0669C70.9996 72.456 70.3996 72.456 69.9996 72.0669Z",
    fill: "#EADB9E"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.7496 60.1039L65.3009 65.4039L70.7024 70.6579L76.1954 65.401L70.7496 60.1039ZM68.9537 57.6656C69.936 56.7102 71.5632 56.7102 72.5455 57.6656L78.6455 63.5991C79.651 64.5771 79.651 66.2306 78.6455 67.2086L78.6368 67.2171L78.6367 67.2171L72.4403 73.1472C71.4578 74.0975 69.9342 74.0958 68.9537 73.1421L62.8537 67.2086C61.8482 66.2306 61.8482 64.5771 62.8537 63.5991L68.9537 57.6656Z",
    fill: "#313E48"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M111.1 70.6078H102.5C101.9 70.6078 101.5 70.1214 101.5 69.6351V61.2698C101.5 60.6862 102 60.2971 102.5 60.2971H111.1C111.7 60.2971 112.1 60.7835 112.1 61.2698V69.6351C112.1 70.1214 111.7 70.6078 111.1 70.6078Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103 61.7971V69.1078H110.6V61.7971H103ZM100 61.2698C100 59.7246 101.311 58.7971 102.5 58.7971H111.1C112.586 58.7971 113.6 60.0141 113.6 61.2698V69.6351C113.6 70.8908 112.586 72.1078 111.1 72.1078H102.5C101.014 72.1078 100 70.8908 100 69.6351V61.2698Z",
    fill: "#313E48"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8996 52.8074C85.9996 52.8074 83.5996 50.4729 83.5996 47.652C83.5996 44.8312 85.9996 42.4967 88.8996 42.4967C91.7996 42.4967 94.1996 44.8312 94.1996 47.652C94.1996 50.4729 91.8996 52.8074 88.8996 52.8074Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.8996 43.9967C86.7886 43.9967 85.0996 45.6985 85.0996 47.652C85.0996 49.6056 86.7886 51.3074 88.8996 51.3074C91.0919 51.3074 92.6996 49.6239 92.6996 47.652C92.6996 45.6985 91.0106 43.9967 88.8996 43.9967ZM82.0996 47.652C82.0996 43.9639 85.2106 40.9967 88.8996 40.9967C92.5886 40.9967 95.6996 43.9639 95.6996 47.652C95.6996 51.3219 92.7073 54.3074 88.8996 54.3074C85.2106 54.3074 82.0996 51.3402 82.0996 47.652Z",
    fill: "#313E48"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8996 87.0465C85.9996 87.0465 83.5996 84.712 83.5996 81.8912C83.5996 79.0703 85.9996 76.7358 88.8996 76.7358C91.7996 76.7358 94.1996 79.0703 94.1996 81.8912C94.1996 84.712 91.8996 87.0465 88.8996 87.0465Z",
    fill: "#94C1AE"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.8996 78.2358C86.7886 78.2358 85.0996 79.9376 85.0996 81.8912C85.0996 83.8447 86.7886 85.5465 88.8996 85.5465C91.0919 85.5465 92.6996 83.863 92.6996 81.8912C92.6996 79.9376 91.0106 78.2358 88.8996 78.2358ZM82.0996 81.8912C82.0996 78.203 85.2106 75.2358 88.8996 75.2358C92.5886 75.2358 95.6996 78.203 95.6996 81.8912C95.6996 85.561 92.7073 88.5465 88.8996 88.5465C85.2106 88.5465 82.0996 85.5793 82.0996 81.8912Z",
    fill: "#313E48"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M107.1 60.1999V50.3756C107.1 48.8192 105.8 47.4575 104.1 47.4575H95.0996",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.0996 45.9575H104.1C106.621 45.9575 108.6 47.9842 108.6 50.3756V60.1999H105.6V50.3756C105.6 49.6543 104.978 48.9575 104.1 48.9575H95.0996V45.9575Z",
    fill: "#313E48"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8994 58.7408V50.181C70.8994 48.8192 71.9994 47.7493 73.3994 47.7493H83.5994",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.3994 49.2493C72.7884 49.2493 72.3994 49.6865 72.3994 50.181V58.7408H69.3994V50.181C69.3994 47.9519 71.2104 46.2493 73.3994 46.2493H83.5994V49.2493H73.3994Z",
    fill: "#313E48"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.8998 66.3688H78.2998V63.3688H83.8998V66.3688Z",
    fill: "#313E48"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.5 79.1676V72.0668H71.5V79.1676C71.5 80.1484 72.289 80.9747 73.4 80.9747H83.6V83.9747H73.4C70.711 83.9747 68.5 81.883 68.5 79.1676Z",
    fill: "#313E48"
  })));
};
export { SvgReporting as ReactComponent };
export default __webpack_public_path__ + "static/media/reporting.e0e7893d.svg";